define('lq/events/actions/enablePushNotificationsCommand',[
    'lq/events/actions/eventAction',
    'lq/main',
    'lq/webPushNotifications'
], function (EventAction, main, webPushNotifications) {
    'use strict';

    function EnablePushNotificationsCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(EnablePushNotificationsCommand, EventAction);

    EnablePushNotificationsCommand.typeName = 'EnablePushNotificationsCommand';

    EnablePushNotificationsCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    EnablePushNotificationsCommand.prototype.execute = function (continuation) {
        var self = this;
    
        if (main.areWebNotificationsEnabled() && Notification.permission === 'default')
            webPushNotifications.get(this.piping.application.userId, function (permissionType) {
                if (permissionType === 'granted' && self.eventIsEnabled('granted'))
                    self.triggerEvent('granted');
                else if (permissionType === 'denied' && self.eventIsEnabled('denied'))
                    self.triggerEvent('denied');
                else if (permissionType === 'default' && self.eventIsEnabled('dismissed'))
                    self.triggerEvent('dismissed');
            });
        
        continuation();
    };

    return EnablePushNotificationsCommand;
});
